import { render } from "./DetailDependencyField.vue?vue&type=template&id=e0b7c360"
import script from "./DetailDependencyField.vue?vue&type=script&lang=js"
export * from "./DetailDependencyField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__